/* sd-popup.js — popup raspadinha (réplica do fluxo da referência): abre 1 s depois do DOMContentLoaded em toda página;
   passo 1 raspa a cobertura do cartão (40 % limpo revela, Enter/Espaço revela de uma vez) -> Claim; passo 2 e-mail (cadastro
   pelo formulário nativo da loja, sem recarregar); passo 3 telefone; passo 4 código. X / Esc / "Shop now" fecham e guardam
   sd-pp=fechado no localStorage (não volta mais). Layout desktop (>= 1024 px) ou celular, como os dois layouts da referência.
   Expõe window.sdPopupClose(). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('sd-pp-config');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var LS = cfg.ls || 'sd-pp';
  function ler() { try { return localStorage.getItem(LS) || ''; } catch (e) { return ''; } }
  function marcar(v) { try { if (v) localStorage.setItem(LS, v); else localStorage.removeItem(LS); } catch (e) {} }
  if (ler() === 'fechado') return;

  var mq = window.matchMedia('(min-width: ' + (cfg.bp || 1024) + 'px)');
  var root = null, passo = 1, raspado = false, emailValor = '', foneValor = '', pais = 'US';
  var coverImg = new Image(); coverImg.crossOrigin = 'anonymous'; coverImg.src = cfg.cover;

  function tpl(nome) { var t = document.getElementById('sd-pp-tpl-' + nome); return t ? document.importNode(t.content, true) : null; }

  // ---------- raiz + layout
  function montar() {
    if (root || ler() === 'fechado') return;
    root = document.createElement('div');
    root.id = 'sd-pp-root'; root.setAttribute('data-sd-popup', '');
    root.setAttribute('style', 'position: fixed; outline: none; display: block; inset: 0px; width: 100%; height: 100%; z-index: 2147483647;');
    root.setAttribute('tabindex', '-1'); root.setAttribute('aria-modal', 'true'); root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', 'Promotional popup');
    root.appendChild(tpl(mq.matches ? 'layout-desktop' : 'layout-celular'));
    if (raspado) root.setAttribute('data-sd-raspado', '');
    var x = root.querySelector('[aria-label="Close popup"]');
    x.addEventListener('click', fechar);
    x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fechar(); } });
    document.body.appendChild(root);
    mostrar(passo);
    try { root.focus({ preventScroll: true }); } catch (e) {}
  }
  function fechar() {
    marcar('fechado');
    if (root && root.parentNode) root.parentNode.removeChild(root);
    root = null;
  }
  window.sdPopupClose = fechar;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root) fechar(); });
  // troca de layout quando cruza a largura de corte (como a referência, que remonta o passo)
  function remontar() { if (!root) return; var r = root; root = null; if (r.parentNode) r.parentNode.removeChild(r); montar(); }
  if (mq.addEventListener) mq.addEventListener('change', remontar); else if (mq.addListener) mq.addListener(remontar);

  // ---------- passos
  function outlet() { return root.querySelector('[data-sd-outlet]'); }
  function mostrar(n) {
    passo = n;
    var o = outlet(), logo = o.querySelector('img');
    while (logo.nextSibling) o.removeChild(logo.nextSibling);
    o.appendChild(tpl('passo' + n));
    if (n === 1) ligarPasso1(o);
    else if (n === 2) ligarPasso2(o);
    else if (n === 3) ligarPasso3(o);
    else if (n === 4) ligarPasso4(o);
  }

  // ---------- passo 1: raspadinha
  function ligarPasso1(o) {
    var card = o.querySelector('[data-drag-hold]'), canvas = o.querySelector('canvas#card-cover'), status = o.querySelector('[role="status"]');
    var claim = o.querySelector('#sd-pp-yi382ha1r3dp79u6');
    claim.addEventListener('click', function () { mostrar(2); });
    if (raspado) { revelado(card, canvas, status, true); return; }
    var ctx = canvas.getContext('2d'), W = canvas.width, H = canvas.height, raspando = false, ultimo = null, feito = false, cont = 0;
    function desenhar() { ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, W, H); ctx.drawImage(coverImg, 0, 0, W, H); }
    function fundo() { ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = '#111'; ctx.fillRect(0, 0, W, H); }
    if (coverImg.complete && coverImg.naturalWidth) desenhar(); else { fundo(); coverImg.addEventListener('load', function () { if (!feito) desenhar(); }); }
    function ponto(e) { var b = canvas.getBoundingClientRect(); return { x: (e.clientX - b.left) * W / b.width, y: (e.clientY - b.top) * H / b.height }; }
    function riscar(a, b) {
      var r = cfg.brush || 20;
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = r * 2;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      ctx.beginPath(); ctx.arc(b.x, b.y, r, 0, Math.PI * 2); ctx.fill();
    }
    function fracao() {
      var d; try { d = ctx.getImageData(0, 0, W, H).data; } catch (e) { return 0; }
      var n = 0, t = 0;
      for (var i = 3; i < d.length; i += 4 * 4) { t++; if (d[i] < 64) n++; }
      return t ? n / t : 0;
    }
    function completar() {
      if (feito) return; feito = true; raspado = true;
      revelado(card, canvas, status, false);
    }
    canvas.addEventListener('pointerdown', function (e) { if (feito) return; raspando = true; ultimo = ponto(e); riscar(ultimo, ultimo); try { canvas.setPointerCapture(e.pointerId); } catch (x) {} e.preventDefault(); });
    canvas.addEventListener('pointermove', function (e) {
      if (!raspando || feito) return; var p = ponto(e); riscar(ultimo || p, p); ultimo = p;
      if (++cont % 4 === 0 && fracao() >= (cfg.pct || 0.4)) completar();
    });
    function soltar() { if (!raspando) return; raspando = false; ultimo = null; if (!feito && fracao() >= (cfg.pct || 0.4)) completar(); }
    canvas.addEventListener('pointerup', soltar); canvas.addEventListener('pointercancel', soltar);
    card.addEventListener('keydown', function (e) { if (feito) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ctx.clearRect(0, 0, W, H); completar(); } });
  }
  function revelado(card, canvas, status, imediato) {
    var instr = card.parentNode.querySelector('#sd-pp-t8fdb8j1qm3ca7b0-instructions');
    if (instr) instr.parentNode.removeChild(instr);
    card.setAttribute('tabindex', '-1'); card.setAttribute('aria-label', "You've Got 40% Off"); card.removeAttribute('aria-describedby');
    canvas.style.transition = imediato ? 'none' : 'opacity 180ms'; canvas.style.opacity = '0'; canvas.style.pointerEvents = 'none';
    status.textContent = "You've Got 40% Off";
    root.setAttribute('data-sd-raspado', '');
  }

  // ---------- passo 2: e-mail -> cadastro pelo formulário nativo da loja
  function erro(label, input, msg) {
    // a referência insere a classe de erro no meio da lista (depois de focus-within:ring-2) e devolve o foco ao campo
    if (!input.classList.contains('sd-pp-error')) input.className = input.className.indexOf('focus-within:ring-2 ') >= 0 ? input.className.replace('focus-within:ring-2 ', 'focus-within:ring-2 sd-pp-error ') : input.className + ' sd-pp-error';
    var p = label.querySelector('p[role="alert"]');
    if (!p) { p = document.createElement('p'); p.setAttribute('role', 'alert'); p.className = 'bg-red-100 rounded px-2.5 py-2.5 text-red-600 text-xs'; input.insertAdjacentElement('afterend', p); }
    p.textContent = msg;
    var campo = input.tagName === 'INPUT' ? input : input.querySelector('input[type="tel"]');
    if (campo) try { campo.focus({ preventScroll: true }); } catch (e) {}
  }
  function limparErro(label, input) { input.classList.remove('sd-pp-error'); var p = label.querySelector('p[role="alert"]'); if (p) p.parentNode.removeChild(p); }
  // ---- cadastro do e-mail pelo formulário nativo de cliente da loja (#sd-pp-cadastro, fora da raiz, fora da tela):
  // o anti-spam da loja (hCaptcha) é preso a esse formulário quando o passo 2 abre; no clique válido ele recebe o e-mail e é
  // submetido; o anti-spam segura, resolve o desafio, põe o token e chama form.submit(), que aqui vira um fetch (sem recarregar).
  // Sem anti-spam, o submit vira fetch direto. Se a loja recarregar mesmo assim, volta em ?sd_pp=3 (passo 3).
  var cadastro = null, cadastroPronto = false, cadastroPendente = null;
  function prepararCadastro() {
    cadastro = document.getElementById('sd-pp-cadastro');
    if (!cadastro || cadastro.__sdPreparado) return;
    cadastro.__sdPreparado = true;
    cadastro.submit = enviarCadastro;
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === 'function') {
      try { cap.protect(cadastro, function () { cadastroPronto = true; if (cadastroPendente) { var f = cadastroPendente; cadastroPendente = null; f(); } }); return; } catch (e) {}
    }
    cadastroPronto = true;
  }
  function enviarCadastro() {
    fetch(cadastro.getAttribute('action').split('#')[0], { method: 'POST', body: new FormData(cadastro), credentials: 'same-origin', redirect: 'follow' })
      .then(function (r) { if (!r.ok) console.warn('sd-popup: cadastro respondeu ' + r.status); })
      .catch(function () {})
      .then(function () { if (root && passo === 2) mostrar(3); });
  }
  window.sdPopupCadastro = enviarCadastro; // ponto final do caminho do anti-spam (também usado pela bateria de conferência)
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f) return;
    if (f.id === 'sd-pp-jve29wy53n46xj7d') { e.preventDefault(); return; } // o formulário visível nunca navega: o cadastro vai pelo oculto
    if (f === cadastro) { if (e.defaultPrevented) return; e.preventDefault(); enviarCadastro(); } // sem anti-spam: fetch direto
  });
  function ligarPasso2(o) {
    var form = o.querySelector('form'), label = form.querySelector('label'), input = form.querySelector('input'), btn = form.querySelector('button');
    prepararCadastro();
    if (emailValor) input.value = emailValor;
    input.addEventListener('input', function () { emailValor = input.value; });
    function disparar() {
      if (!cadastroPronto) { cadastroPendente = disparar; return; }
      if (cadastro.requestSubmit) cadastro.requestSubmit(); else cadastro.submit();
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { erro(label, input, 'Invalid email'); return; }
      limparErro(label, input); emailValor = v;
      if (!cadastro) { mostrar(3); return; }
      cadastro.elements['contact[email]'].value = v; cadastro.elements['return_to'].value = location.pathname + '?sd_pp=3';
      btn.setAttribute('aria-disabled', 'true'); btn.disabled = true;
      disparar();
    });
  }

  // ---------- passo 3: telefone
  function ligarPasso3(o) {
    var form = o.querySelector('form'), label = form.querySelector('label'), input = form.querySelector('input[type="tel"]'), sel = form.querySelector('select'), flag = form.querySelector('.PhoneInputCountryIconImg');
    sel.value = pais;
    sel.addEventListener('change', function () {
      pais = sel.value;
      var nome = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : pais;
      flag.alt = nome; flag.hidden = pais !== 'US';
    });
    if (foneValor) input.value = foneValor;
    input.addEventListener('input', function () { foneValor = input.value; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var dig = (input.value || '').replace(/\D/g, '');
      if (dig.length < 7 || dig.length > 15) { erro(label.querySelector('.PhoneInput') ? label : label, input.closest('.PhoneInput') || input, 'Invalid phone number'); return; }
      var alvo = input.closest('.PhoneInput') || input; alvo.classList.remove('sd-pp-error'); var p = label.querySelector('p[role="alert"]'); if (p) p.parentNode.removeChild(p);
      foneValor = input.value; mostrar(4);
    });
  }

  // ---------- passo 4: código + Shop now
  function ligarPasso4(o) {
    var btn = o.querySelector('button'); btn.addEventListener('click', fechar);
  }

  // ---------- gatilho: 1 s depois do DOMContentLoaded (volta do desafio anti-spam: direto no passo 3)
  var volta = /[?&]sd_pp=3\b/.test(location.search) || (ler() === 'enviando' && /customer_posted=true/.test(location.search));
  if (volta) { passo = 3; raspado = true; marcar(''); }
  function agendar() { setTimeout(montar, cfg.atraso || 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', agendar); else agendar();
})();
